export const CRUNCHBASE_EXPORT_FIELD_OPTIONS = [
  { value: "organizationName", label: "Organization Name" },
  { value: "originalLeadType", label: "Original Lead Type" },
  { value: "correctedLeadType", label: "Corrected Lead Type" },
  { value: "teamComments", label: "Team Comments" },
  { value: "lastUpdated", label: "Last Updated" },
  { value: "justification", label: "Justification" },
  { value: "industries", label: "Industries" },
  { value: "bucketIndustries", label: "Bucket Industries" },
  { value: "country", label: "Country" },
  { value: "founded", label: "Founded" },
  { value: "employees", label: "Employees" },
  { value: "investmentStage", label: "Investment Stage" },
  { value: "estimatedRevenueRange", label: "Estimated Revenue Range" },
  { value: "lastFundingDate", label: "Last Funding Date" },
  { value: "totalFundingAmount", label: "Total Funding Amount" },
  { value: "crunchbaseRank", label: "Crunchbase Rank" },
  { value: "investorType", label: "Investor Type" },
  { value: "topInvestors", label: "Top 5 Investors" },
  { value: "leadInvestors", label: "Lead Investors" },
  { value: "website", label: "Website" },
  { value: "crunchbaseUrl", label: "Crunchbase URL" },
  { value: "globaldataMatch", label: "GlobalData Match" },
  { value: "companyHouseMatch", label: "Company House Match" },
  { value: "clientMatch", label: "Client Match" },
  { value: "peopleSummary", label: "People" },
  { value: "fundingRoundsSummary", label: "Funding Rounds" },
  { value: "latestFundingRound", label: "Latest Funding Round" },
  { value: "latestFundingRoundDate", label: "Latest Funding Round Date" },
  { value: "latestFundingRoundLeadInvestors", label: "Latest Round Lead Investors" },
];

export const DEFAULT_CRUNCHBASE_EXPORT_FIELDS = [
  "organizationName",
  "correctedLeadType",
  "country",
  "industries",
  "founded",
  "employees",
  "investmentStage",
  "lastFundingDate",
  "totalFundingAmount",
  "topInvestors",
  "leadInvestors",
  "website",
  "crunchbaseUrl",
];

export const GLOBALDATA_EXPORT_FIELD_OPTIONS = [
  { value: "companyName", label: "Company Name" },
  { value: "croScore", label: "CRO Score" },
  { value: "croTier", label: "CRO Tier" },
  { value: "cdmoScore", label: "CDMO Score" },
  { value: "cdmoTier", label: "CDMO Tier" },
  { value: "uniqueDrugCount", label: "Unique Linked Drugs" },
  { value: "matchedToCrunchbase", label: "Matched to Crunchbase" },
  { value: "matchedToCompanyHouse", label: "Matched to Company House" },
  { value: "matchedToClient", label: "Existing Client" },
  { value: "clientLifecycleStatus", label: "Client Lifecycle Status" },
  { value: "headquarters", label: "Headquarters" },
  { value: "entityType", label: "Entity Type" },
  { value: "relationshipType", label: "Relationship Type" },
  { value: "companyHighestDevelopmentStage", label: "Highest Development Stage" },
  { value: "companyDrugCount", label: "Company Drug Count" },
  { value: "overview", label: "Overview" },
  { value: "companyId", label: "Company ID" },
  { value: "numberOfEmployees", label: "Employees" },
  { value: "annualRevenueUsdM", label: "Annual Revenue USD m" },
  { value: "capitalRaisedPast3YearsUsdM", label: "Capital Raised Past 3 Years USD m" },
  { value: "grantsReceivedPast3YearsUsdM", label: "Grants Received Past 3 Years USD m" },
  { value: "url", label: "Company URL" },
];

export const DEFAULT_GLOBALDATA_EXPORT_FIELDS = [
  "companyName",
  "croScore",
  "croTier",
  "cdmoScore",
  "cdmoTier",
  "uniqueDrugCount",
  "matchedToCrunchbase",
  "matchedToCompanyHouse",
  "matchedToClient",
  "clientLifecycleStatus",
  "headquarters",
  "entityType",
  "relationshipType",
  "companyHighestDevelopmentStage",
  "companyDrugCount",
  "annualRevenueUsdM",
  "overview",
];

export const COMPANYHOUSE_EXPORT_FIELD_OPTIONS = [
  { value: "companyName", label: "Company Name" },
  { value: "companyNumber", label: "Company Number" },
  { value: "companyStatus", label: "Company Status" },
  { value: "companyType", label: "Company Type" },
  { value: "incorporatedOn", label: "Incorporated On" },
  { value: "registeredOfficeAddress", label: "Registered Office Address" },
  { value: "sicCodes", label: "SIC Codes" },
  { value: "officerCount", label: "Officer Count" },
  { value: "pscCount", label: "PSC Count" },
  { value: "sourceUrl", label: "Source URL" },
  { value: "matchedToCrunchbase", label: "Matched to Crunchbase" },
  { value: "matchedToGlobaldata", label: "Matched to GlobalData" },
  { value: "matchedToClient", label: "Existing Client" },
  { value: "clientLifecycleStatus", label: "Client Lifecycle Status" },
  { value: "primaryCrunchbaseMatchName", label: "Crunchbase Match" },
  { value: "primaryGlobaldataMatchName", label: "GlobalData Match" },
  { value: "primaryClientMatchName", label: "Client Match" },
];

export const DEFAULT_COMPANYHOUSE_EXPORT_FIELDS = [
  "companyName",
  "companyNumber",
  "companyStatus",
  "companyType",
  "incorporatedOn",
  "registeredOfficeAddress",
  "sicCodes",
  "officerCount",
  "pscCount",
  "sourceUrl",
  "clientLifecycleStatus",
];
